import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { referencesActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class References extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newReference, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Referências'}
          classes={classes}
          newResource={newReference}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'referencias'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.references.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(referencesActions.openModal())
    },
    closeModal: () => {
      dispatch(referencesActions.closeModal())
    },
    newReference: reference => {
      dispatch(referencesActions.newFormReference(reference))
    },
    resetState: () => {
      dispatch(referencesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(References))



// WEBPACK FOOTER //
// ./src/containers/References/index.js